module.exports = __webpack_public_path__ + "static/img/mv-test-pc.cc8fd26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mv-test-pc.png
// module id = uGfz
// module chunks = 0